import React from "react";

const WhiteErrorTriangleIcon = () => {
  return (
    <svg
      width="28"
      height="24"
      viewBox="0 0 28 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.427 18.857a1.714 1.714 0 1 0-3.429 0 1.714 1.714 0 0 0 3.429 0m-1.715-12c-.712 0-1.285.573-1.285 1.286v6c0 .712.573 1.286 1.285 1.286.713 0 1.286-.574 1.286-1.286v-6c0-.713-.573-1.286-1.286-1.286m0-6.857c.761 0 1.463.402 1.849 1.06l11.571 19.715c.391.664.391 1.484.01 2.148A2.147 2.147 0 0 1 25.285 24H2.14a2.147 2.147 0 0 1-1.859-1.077 2.152 2.152 0 0 1 .01-2.148L11.865 1.061A2.139 2.139 0 0 1 13.712 0"
        fill="#FFF"
        fill-rule="evenodd"
      />
    </svg>
  );
};

export default WhiteErrorTriangleIcon;
